import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setNextModal, closePaymentModal, openOrderCloseModal, addPayment, calculateChange, orderPaid } from '../actions/index';
import { Modal } from 'react-bootstrap';
import PaymentTypes from './payment_types';
import PaymentCashButtons from './payment_cash_buttons';

class ModalOrderPayment extends Component {
  constructor(props) {
    super(props);

    this.state = {
      paymentType: '',
      paymentAmount: 0.00,
      paymentVisible: false,
    }
  }

  // When the user switches payment type, change state and focus
  handlePaymentTypeChange = type => {
    this.setState({ paymentType: type, paymentAmount: Math.abs(this.props.orders[this.props.modals.modalOrderID].grandtotal).toFixed(2), paymentVisible: true });

    // Using a ref to access the DOM and set the focus of the input
    if (this.textInput) {
      this.textInput.focus();
    }
  }

  // Handle cash buttons pressed in <PaymentCashButtons />
  handlePaymentCashButton = cashTendered => {
    this.setState({ paymentAmount: cashTendered.toFixed(2) });
  }

  // Change the order amount in the text box
  handleAmountChange = amount => {
    this.setState({ paymentAmount: amount });
  }

  // Add payment to the app state, then figure out next steps
  handleAddPayment = () => {
    if (this.state.paymentType !== '' && this.state.paymentAmount !== '') {
      this.props.addPayment(this.props.modals.modalOrderID, this.state.paymentType, parseFloat(this.state.paymentAmount)).then( () => {

        // Get all the payments (multiple?) total
        let payments = Object.values(this.props.orders[this.props.modals.modalOrderID].payments);
        let paymentsTotal = payments.reduce( function(acc, obj) {
          return acc + obj.amount;
        }, 0);

        // If the payments cover the total then calculate
        // change and load the next modal
        if (paymentsTotal >= this.props.orders[this.props.modals.modalOrderID].grandtotal) {
          this.props.calculateChange(this.props.modals.modalOrderID, paymentsTotal);

          // The order has been paid
          this.props.orderPaid(this.props.modals.modalOrderID);

          this.props.setNextModal(this.props.openOrderCloseModal);
          this.setState({ paymentType: '', paymentAmount: '', paymentVisible: false });
          this.props.closePaymentModal();
        } else {
          // Spot here to reset modal to support multiple payments
          this.setState({ paymentType: '', paymentAmount: '', paymentVisible: false });
        }
      });
    }
  }

  // Reset the payment modal before closing it
  handleClosePaymentModal = () => {
    this.setState({ paymentType: '', paymentAmount: '', paymentVisible: false });
    this.props.closePaymentModal();
  }

  // While making payments, show how much total is left to pay
  getTotalRemaining() {
    if (this.props.modals.modalOrderID !== '') {
      let grandtotal = this.props.orders[this.props.modals.modalOrderID].grandtotal;

      // Get all the payments (multiple?) total
      let payments = Object.values(this.props.orders[this.props.modals.modalOrderID].payments);
      let paymentsTotal = payments.reduce( function(acc, obj) {
        return acc + obj.amount;
      }, 0);

      return grandtotal - paymentsTotal;
    } else {
      return 0;
    }
  }

  // Show all the payments so far in the payment modal (not needed right now?)
  renderCurrentPayments() {
    if (this.props.modals.modalOrderID !== '') {
      let payments = Object.values(this.props.orders[this.props.modals.modalOrderID].payments);

      return payments.map( (payment, index) => {
        return(
          <div key={index}>
            {payment.type} - {parseFloat(payment.amount).toFixed(2)}
          </div>
        );
      });
    }
  }

  // Show which total text depending if you made a payment already or not
  renderTotal() {
    if (this.props.modals.modalOrderID !== '') {
      let grandtotal = this.props.orders[this.props.modals.modalOrderID].grandtotal;

      if (this.getTotalRemaining() < grandtotal) {
        return 'Your new total is $' + Math.abs(this.getTotalRemaining()).toFixed(2);
      } else {
        return 'Your total is $' + Math.abs(grandtotal).toFixed(2);
      }
    }
  }

  render() {
    let order_name = '';

    if (this.props.modals.modalOrderID !== '') {
      order_name = this.props.orders[this.props.modals.modalOrderID].order_name;
    }

    return(
      <Modal show={this.props.modals.showPaymentModal} onHide={this.handleClosePaymentModal}>
        <Modal.Header closeButton>
        </Modal.Header>
        <Modal.Body>
          <div>
            <div>
              <span className="h1 text-grey">{order_name.toUpperCase()}</span>
            </div>
            <div className="mt-1">
              <span className="h1 text-primary">
                {this.renderTotal()}
              </span>
            </div>
            <div className="mt-1">
              <span className="h1 text-primary">How would you like to pay?</span>
            </div>
            <br />
            <PaymentTypes paymentType={this.state.paymentType} handlePaymentTypeChange={this.handlePaymentTypeChange} />

            {this.state.paymentVisible &&
              <div>
                <br />
                <PaymentCashButtons handlePaymentCashButton={this.handlePaymentCashButton} orderTotal={this.getTotalRemaining()} />
                <br />
                <input type="text" ref={(input) => { this.textInput = input; }} width="20" autoFocus onFocus={event => event.target.select()} className="form-control" onChange={event => this.handleAmountChange(event.target.value)} value={this.state.paymentAmount} />
              </div>
            }
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button type="button" className="btn btn-secondary" onClick={this.handleClosePaymentModal}>CLOSE</button>&nbsp;
          <button type="button" className="btn btn-primary" onClick={this.handleAddPayment}>PAY + RECEIPT</button>&nbsp;
          <button type="button" className="btn btn-primary" onClick={this.handleAddPayment}>PAY</button>
        </Modal.Footer>
      </Modal>
    );
  }
}

function mapStateToProps({ modals, orders }) {
  return { modals, orders };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators( { setNextModal, closePaymentModal, openOrderCloseModal, addPayment, calculateChange, orderPaid }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalOrderPayment);



// WEBPACK FOOTER //
// ./src/containers/modal_order_payment.js